import React from 'react';
import { readRemoteFile } from 'react-papaparse';
import distributorsData from './data/distributors.csv';
import '../scss/distributors.scss';

function renderDistributorLogo(name, image, url) {
  var distributorLogo = '';
  
  if (name === 'Distributor Name') {
    distributorLogo = 'Distributors';
  } else {
    distributorLogo = (
      <div className="align-self-center">
        <a href={url}><img className="distributor-image" src={require(`./images/distributorLogos/${image}`)} alt={name}/></a>
      </div>
    )
  }

  return distributorLogo;
}

function renderDistributorInfo(name, phone, url) {
  var distributorInfo = '';

  if (name === 'Distributor Name') {
    distributorInfo = '';
  } else {
    distributorInfo = (
      <div className="text-left align-self-center text-nowrap">
        <a href={url}><b>{name}</b></a>
        <p>{phone}</p>
      </div>
    )
  }
  
  return distributorInfo;
}

function renderTableRow(rowArray, Tag) {
  var rowContent = [];

  if(rowArray[0] === 'Distributor Name') {
    rowContent.push(<Tag colSpan="2" className="align-middle">{renderDistributorLogo(rowArray[0], rowArray[1], rowArray[3])}</Tag>)
  } else {
    rowContent.push(<Tag className="align-middle">{renderDistributorLogo(rowArray[0], rowArray[1], rowArray[3])}</Tag>)
    rowContent.push(<Tag className="align-middle">{renderDistributorInfo(rowArray[0], rowArray[2], rowArray[3])}</Tag>);
  }

  for (var i = 4; i < rowArray.length; i++) {
    rowContent.push(<Tag className="align-middle">{rowArray[i]}</Tag>);
  }
  return rowContent;
}

function renderTableBody(tableBody) {
  var tableBodyContent = [];
  for (var i = 1; i < tableBody.length; i++) {
    tableBodyContent.push(<tr>{renderTableRow(tableBody[i], 'td')}</tr>);
  }
  return <tbody>{tableBodyContent}</tbody>;
}

function renderTableHead(tableHead) {
  var tableHeadContent = [];
  tableHeadContent.push(<tr>{renderTableRow(tableHead, 'th')}</tr>);
  return <thead>{tableHeadContent}</thead>;
}

function renderTable(tableData) {
  var tableContent = [];
  tableContent.push(renderTableHead(tableData[0]));
  tableContent.push(renderTableBody(tableData));
  return <table className="table table-striped text-center">{tableContent}</table>
}

class Distributors extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataResults: null
    };
  }

  componentDidMount() {
    readRemoteFile(distributorsData, {
      complete: (results) => {
        this.setState({dataResults: results});
      }
    });
  }

  render() {
    if (this.state.dataResults) {
      var csvdata = this.state.dataResults;
      var table = renderTable(csvdata.data);
      return (
        <div className="distributor-container">
          {table}
        </div>
        );
    } else {
      return ('');
    }
  }
}

export default Distributors;
